import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

// Import Setting Service and User, Credential Model
import { ApiService, SettingService } from '../../common/modules/core/services';

@Injectable()
export class HolRegisterService {
    private activationUrl = '/activations';
    private holParentUrl = '/hol/parent';
    private apiUrl = '';

    constructor (
        private settingService: SettingService,
        private apiService: ApiService
    ) {
        this.apiUrl = this.settingService.getSetting('api_service_domain');
    }

    postActivationEmail(role:string, email: string): Observable<any> {
        const requestUrl = this.apiUrl + this.activationUrl;
        const body = JSON.stringify({
                        'role': role,
                        'email': email
                     });
        
        return this.apiService.post(requestUrl, body);
    }

    verifyActivationToken(token: string): Observable<any> {
        const requestUrl = this.apiUrl + this.activationUrl + "/" + token;

        return this.apiService.get(requestUrl);
    }

    postNoneAisAccount(email: string) {
        const requestUrl = this.apiUrl + this.holParentUrl + "/register";
        const body = JSON.stringify({
                        'email': email,
                        'family_name': "",
                        'given_name': "",
                        'phone': ""
                     });
        return this.apiService.post(requestUrl, body);
    }
    
    setPasswordWithActivationToken(token: string, password: string): Observable<any> {
        const requestUrl = this.apiUrl + this.activationUrl + "/" + token;
        // TODO: update body content
        const body = JSON.stringify({password});

        return this.apiService.patch(requestUrl, body);
    }
}


// WEBPACK FOOTER //
// ./src/holiday/services/HolRegisterService.ts